<div class="d-flex-center m-t-20" *ngIf="!sale?.package?.packageBenefits" @fadeInOut>
    <img src="assets/images/spinner1.gif" width="70">
</div>
<ng-container *ngIf="sale?.package?.packageBenefits">
    <div class="p-10 p-b-0" @fadeInOut>
        <!-- Items -->
        <div class="package-card cursor-pointer m-t-10 m-b-10">
            <div class="d-flex align-items-center" (click)="onShowItems()">
                <div class="w-100" style="position: relative;">
                    <div class="d-flex-between">
                        <div class="d-flex align-items-center font-14 font-bold">
                            ¿Qué incluye este pack?
                        </div>
                    </div>
                </div>
                <div class="d-flex-center align-items-center" style="max-width: 80px; margin-top: 2px;">
                    <i class="mdi mdi-chevron-right mdi-28px" *ngIf="!showItems"></i>
                    <i class="mdi mdi-chevron-down mdi-28px" *ngIf="showItems"></i>
                </div>
            </div>

            <div class="d-flex" *ngFor="let item of sale.package?.packageBenefits; let i = index">
                <div class="package-card-item cursor-pointer m-t-20" [ngClass]="i+1 != sale.package?.packageBenefits.length ? 'border-bottom' : ''" *ngIf="showItems" (click)="onBenefitDetail(item)">
                    <div class="d-flex">
                        <div class="d-flex-center align-items-center">
                            <div class="image-container">
                                <img [src]="item.data.thumbnailUrl">
                            </div>
                        </div>
                        <div class="m-l-10 w-100 d-flex align-items-center">
                            <div>
                                <div class="d-flex align-items-center font-11">
                                    {{item.data.name}}
                                </div>
                                <div class="d-flex align-items-center font-11">
                                    <div *ngIf="item.type == 'giftcard' && item.data.type != 3" class="d-flex-center align-items-center"><i class="mdi mdi-gift-outline mr-2"></i> Tarjeta de Regalo</div>
                                    <div *ngIf="item.type == 'giftcard' && item.data.type == 3" class="d-flex-center align-items-center"><i class="mdi mdi-tshirt-crew-outline mr-2"></i> Merch</div>
                                    <div *ngIf="item.type == 'coupon' && item.data.scratchId == null" class="d-flex-center align-items-center"><i class="mdi mdi-ticket-percent-outline mr-2"></i> Cupón</div>
                                    <div *ngIf="item.type == 'coupon' && item.data.scratchId != null" class="d-flex-center align-items-center"><i class="mdi mdi-ticket-percent-outline mr-2"></i> Premio</div>
                                    <div *ngIf="item.type == 'event'" class="d-flex-center align-items-center"><i class="mdi mdi-ticket-confirmation-outline mr-2"></i> Evento</div>
                                    <div *ngIf="item.type == 'cashless'" class="d-flex-center align-items-center"><i class="mdi mdi-cash-minus mr-2"></i> Cashless</div>
                                    <div *ngIf="item.type == 'pass'" class="d-flex-center align-items-center"><i class="mdi mdi-map-legend mr-2"></i> Pase</div>
                                    <div *ngIf="item.type == 'scratch'" class="d-flex-center align-items-center"><i class="mdi mdi-gesture-tap-button mr-2"></i> Raspadita</div>
                                    <div *ngIf="item.type == 'package'" class="d-flex-center align-items-center"><i class="mdi mdi-gesture-tap-button mr-2"></i> Pack</div>
                                </div>
                            </div> 
                        </div>
                        <div class="m-l-10 d-flex-between align-items-center">
                            <div class="d-flex align-items-center font-11 font-bold">
                                <i class="mdi mdi-chevron-right mdi-28px"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="actionOption == 1" class="d-flex-center">
            <div class="text-center">
                <div class="font-16 m-t-10">Activá el pack para habilitar los ítems</div>
                <button class="btn btn-dark btn-wmd m-t-10 w-100" (click)="openConfirmModal(confirmModal)" style="padding: 8px 40px; border-radius: 50px;">Activar</button>
            </div>
        </div>
        <div *ngIf="actionOption == 2">
            <app-send-package [sale]="sale"></app-send-package>
        </div>
        <div class="d-flex-center m-t-20">
            <div class="text-center" (click)="actionOption = 1" [ngClass]="actionOption == 1 ? 'btn-action-active' : 'btn-action'">
                <i class="mdi mdi-package-variant-closed" style="font-size: 24px;"></i>
                <div class="font-12" style="margin-top: -8px;">Mi Pack</div>
            </div>
            <div class="text-center m-l-10" (click)="actionOption = 2" [ngClass]="actionOption == 2 ? 'btn-action-active' : 'btn-action'">
                <i class="mdi mdi-gift-outline" style="font-size: 24px;"></i>
                <div class="font-12" style="margin-top: -8px;">Regalar</div>
            </div>
        </div>
        <ng-container *ngIf="!showMoreDetails">
            <div class="d-flex-center text-muted m-t-20" (click)="showMoreDetails = true">
                <div class="font-14">Más detalles</div>
                <i class="mdi mdi-arrow-down font'18"></i>
            </div> 
        </ng-container>
        <ng-container *ngIf="showMoreDetails">
            <div class="d-flex-center text-muted m-t-20" (click)="showMoreDetails = false">
                <div class="font-14">Menos detalles</div>
                <i class="mdi mdi-arrow-up font'18"></i>
            </div>
            <div class="border-top p-t-10 m-t-10">
                <div class="d-flex-between">
                    <div class="font-14 font-bold">Regalo para: </div>
                    <div (click)="showGiviNote(sale.transactionNotes, sale.id, sale.customerOwnerId)">
                        <div class="mr-auto tag" *ngIf="sale.transactionNotes == null">Agregar Nota</div>
                        <div class="mr-auto tag" *ngIf="sale.transactionNotes != null"
                            [ngStyle]="{'background-color':sale.transactionNotes.color, 'color':'#ffffff'}">
                            {{sale.transactionNotes.note.length > 12? sale.transactionNotes.note.slice(0,9) + '...': sale.transactionNotes.note}}
                        </div>
                    </div>
                </div> 
            </div>
            <div class="border-top p-t-10 m-t-10">
                <div class="d-flex-between font-14">
                    <div class="font-bold">Vencimiento: </div>
                    <div class="font-12">{{sale.transactions[0].expirationAt | date: 'MMM dd yyyy' | titlecase}}</div>
                </div>
            </div>
            <div class="border-top p-t-10 m-t-10">
                <div class="d-flex-between font-14">
                    <div class="font-bold">Descripción: </div>
                    <div>
                        <div *ngIf="sale.package.description.length >= 18 && !showAllDesc" class="font-12">{{sale.package.description | truncate:18 :true}} 
                            <span class="text-muted" (click)="showAllDesc = true" style="text-decoration: underline;"> Ver más</span>
                        </div>
                        <div *ngIf="sale.package.description.length < 18 || showAllDesc" class="font-12">{{sale.package.description }}
                            <span *ngIf="sale.package.description.length >= 18" class="text-muted" (click)="showAllDesc = false" style="text-decoration: underline;"> Ver menos</span>
                        </div>
                    </div>
                </div> 
            </div>
        </ng-container>

    </div>
</ng-container>  

<!-- MODAL -->
<app-package-benefit-detail-modal></app-package-benefit-detail-modal>

<app-givi-note-modal [giviNote]="giviNote" [transactionId]="transactionId" [customerOwnerId]="customerOwnerId" [isPackage]="true"
    [countryNote]="country" (onUpdateNote)="onUpdateNote($event)"></app-givi-note-modal>

<!-- confirmModal -->
<ng-template #confirmModal let-modal>
    <div class="p-20">
        <div class="d-flex-center font-16 font-bold">
            ¿Deseás activar el pack?
        </div>
        <div class="m-t-20 text-center">
            <div class="font-14">Al activar el pack vas a habilitar los {{this.sale.package.packageBenefits.length}} ítems. De esta forma vas a poder canjearlos o regalarlos por separado.</div>
            <div class="font-14 m-t-10">
                <b>Importante: </b>  Si querés regalar el pack completo no lo activés.
            </div>
        </div>
        <div class="d-flex-center m-t-20" (click)="activeTransactionPackage()">
            <button class="btn btn-dark" style="padding: 5px 40px; border-radius: 25px; text-transform: none;">Activar</button>
        </div>
        <div class="font-14 text-muted text-center m-t-10" (click)="modal.dismiss()">Cerrar</div>
    </div> 
</ng-template>

